/* Factory */
SUGApp.service('myGroupsFactory', ['SUGUtilities', function (SUGUtilities) {
    var frmObject = {};
    var dateAndTZFormats = {};
    var groupsSettings = [];
    var myGroups = [];
    var groupMembers = [];
    var memberInfo = {
        memberId: 0,
        parentId: 0,
        isSubAdmin: false
    };
    var settingCategory = {};
    var cloudSponge = null;

    // these are keyed by member
    var memberContactDetails = {};
    var memberSignups = {};
    var memberMessages = {};

    var factory = {
        setFrmObject: function (obj) {
            frmObject = obj;
        },

        getFrmObject: function () {
            return frmObject;
        },

        setDateAndTZFormats: function (data) {
            dateAndTZFormats = data;
        },

        getDateAndTZFormats: function () {
            return dateAndTZFormats;
        },

        setGroupsSettings: function (data) {
            groupsSettings = data;
        },

        getGroupsSettings: function () {
            return groupsSettings;
        },

        setMyGroups: function (data) {
            myGroups = data;
        },

        getMyGroups: function () {
            return myGroups;
        },

        setGroupMembers: function (data) {
            groupMembers = data;
        },

        getGroupMembers: function () {
            return groupMembers;
        },

        setMemberInfo: function (data) {
            memberInfo = data;
        },

        getMemberInfo: function () {
            return memberInfo;
        },

        setSettingCategory: function (data) {
            settingCategory = data;
        },

        getSettingCategory: function () {
            return settingCategory;
        },

        setCloudSpongeServices: function (data) {
            cloudSponge = data;
        },

        getCloudSpongeServices: function () {
            return cloudSponge;
        },

        setMemberContactDetails: function (key, data) {
            memberContactDetails[key] = data;
        },

        getMemberContactDetails: function (key) {
            return memberContactDetails[key] ? memberContactDetails[key] : [];
        },

        setMemberSignups: function (key, data) {
            memberSignups[key] = data;
        },

        getMemberSignups: function (key) {
            return memberSignups[key] ? memberSignups[key] : [];
        },

        setMemberMessages: function (key, data) {
            memberMessages[key] = data;
        },

        getMemberMessages: function (key) {
            return memberMessages[key] ? memberMessages[key] : [];
        }
    };

    return factory;

}]);

/* Service */
SUGApp.service('myGroupsService', ['SUGUtilities', 'globalJSService', 'globalService', '$window', '$location', '$q', function (SUGUtilities, globalJSService, globalService, $window, $location, $q) {

    var service = {
        // use this to check if the server response is invalid
        ajaxResultInvalid: function (result) {
            return (typeof result.data === 'undefined' || !result.data.SUCCESS || !result.data.DATA);
        },

        // use this if you just need to get the error message from the server response
        getAjaxResponseMessage: function (result) {
            if (typeof result.data !== 'undefined') {
                return SUGUtilities.resultErrorHandler(result.data);
            } else {
                return '';
            }
        },

        // use this for displaying an error modal
        errorHandler: function (errorObj) {
            var errMessage = SUGUtilities.resultErrorHandler(errorObj);
            if (errMessage.indexOf('Make sure you are logged in and have an active session.') >= 0) {
                $window.location.reload();
                return;
            }
            // no longer logged in
            if(errorObj.CODE && errorObj.CODE === 1002){
                $window.location.reload();
                return;
            } else {
                SUGUtilities.showMagnificAlert(errMessage, 'error', '', 'Sorry!');
            }
        },

        // used to verify page access
        checkPageAccess: function(){
            var deferred = $q.defer();
            globalService.checkPermission({
                permissioncode: 'ManageGroups'
            }).then(function (response) {
                if (!service.ajaxResultInvalid(response)) {
                    // if authType is present, it must be 'A'
                    var r = SUGUtilities.lowerCaseKeys(response);
                    if (r.data.success && (!r.data.data.authtype || r.data.data.authtype == 'A')) {
                        deferred.resolve();
                    } else {
                        $location.path('/');
                        deferred.reject();
                    }
                } else {
                    $location.path('/');
                    deferred.reject();
                }
            });
            return deferred.promise;
        },

        getMyGroups: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.getMyGroups', 45000);
        },

        getGroupMembers: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.getMembersOfGroup', 15000);
        },

        getContactDetails: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.getContactDetails', 15000);
        },

        removeMemberFromGroup: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.removeMemberFromGroup', 15000);
        },

        removeMembersFromGroup: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.removeMembersFromGroup', 15000);
        },

        createGroup: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.createGroup', 15000);
        },

        saveMySettings: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 'c.saveMySettings', 15000);
        },

        updateGroup: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.updateGroup', 15000);
        },

        updateGroupMember: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.updateGroupMember', 15000);
        },

        isGroupMemberEditable: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.isGroupMemberEditable', 15000);
        },

        getMostRecentMemberSignups: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.getMostRecentMemberSignups', 15000);
        },

        getMostRecentSentMessagesToMember: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.getMostRecentSentMessagesToMember', 15000);
        },

        deleteGroup: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.deleteGroup', 15000);
        },

        canDeleteGroup: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.canDeleteGroup', 15000);
        },

        getCloudSpongeServices: function () {
            return SUGUtilities.APISyncCall('get', '', '', 't.getCloudSpongeServices');
        },

        addGroupMembers: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.addGroupMembers', 30000);
        },

        mergeGroups: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.mergeGroups', 15000);
        },

        transferGroups: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.transferGroups', 15000);
        },

        exportGroups: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.exportGroups', 15000);
        },

        copyGroup: function (data) {
            return SUGUtilities.APISyncCall('post', '', data, 't.copyGroup', 15000);
        },
    };

    return service;

}]);
